import BlackholeTracker from "./blackhole_tracker/client.js";

if (window) {
  window.BlackholeTracker = new BlackholeTracker();
}

// parcel build index.js

(() => {

  document.addEventListener("DOMContentLoaded", function(e) {
    const elements = document.querySelectorAll(".rocksolid-tracker");
    for (const el of elements) {
      el.addEventListener('click', function() {
        const { trackerEvent, trackerAction } = this.dataset;
        if (window.BlackholeTracker && trackerEvent) {
          window.BlackholeTracker.track(trackerEvent, trackerAction);
        }
      });
    }
  });

  //
  // const observeUrlChange = () => {
  //   let oldHref = document.location.href;
  //   const body = document.querySelector("body");
  //   const observer = new MutationObserver(mutations => {
  //     if (oldHref !== document.location.href) {
  //       oldHref = document.location.href;
  //       console.log("Changed");
  //     }
  //   });
  //   observer.observe(body, { childList: true, subtree: true });
  // };
  //
  // window.onload = observeUrlChange;

})();
